import { ActionTree } from 'vuex';
import { Store } from '@/store/types';
import { OrderSearchState, GetOrderIdentificationsByOrderNumberQuery, OrderIdentification, GetOrderByIdQuery } from '../types';
import { getOrderById, getOrderIdentificationsByOrderNumber } from '../service';

export const orderSearchActions: ActionTree<OrderSearchState, Store> = {

  getOrderIdentificationsByOrderNumber({ commit, rootState }, query: GetOrderIdentificationsByOrderNumberQuery): Promise<void> {
    commit('updateLastSearchTerm', query.orderNumber);
    commit('getOrderIdentificationsByOrderNumberStarted');
    return getOrderIdentificationsByOrderNumber(query)
      .then((orderIdentifications: OrderIdentification[]) => {
        commit('getOrderIdentificationsByOrderNumberSucceeded', orderIdentifications);
      })
      .catch((error) => {
        commit('getOrderIdentificationsByOrderNumberFailed');
        return Promise.reject(error);
      });
  },

  getCurrentOrder({ commit, state }): Promise<void> {
    commit('getCurrentOrderStarted');
    const query: GetOrderByIdQuery = {
      orderId: state.currentOrderId!,
    };
    return getOrderById(query)
      .then((order) => {
        commit('getCurrentOrderSucceeded', order);
      })
      .catch((error) => {
        commit('getCurrentOrderFailed');
        return Promise.reject(error);
      });
  },

};
